import { useEffect, useState } from 'react';
import jewmapLogo from '@/assets/jewmap-logo-optimized.webp';

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, 2000);

    const completeTimer = setTimeout(() => {
      onComplete();
    }, 2500);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gradient-to-br from-primary via-primary/90 to-accent transition-all duration-500 ${
        isExiting ? 'opacity-0 scale-110' : 'opacity-100 scale-100'
      }`}
    >
      {/* Logo Container */}
      <div className="flex flex-col items-center gap-6 animate-bounce-in">
        {/* Logo with glow effect */}
        <div className="relative">
          <div className="absolute inset-0 bg-white/30 rounded-full blur-2xl animate-pulse" />
          <img 
            src={jewmapLogo} 
            alt="JewMap" 
            width={112}
            height={112}
            className="relative w-28 h-28 object-contain drop-shadow-2xl animate-float"
          />
        </div>

        {/* App Name */}
        <h1 className="text-4xl font-bold text-white tracking-tight drop-shadow-lg">
          JewMap
        </h1>

        {/* Subtitle */}
        <p className="text-white/80 text-center text-sm max-w-xs animate-fade-in" style={{ animationDelay: '0.3s' }}>
          Découvrez des lieux juifs dans le monde entier
        </p>
      </div>

      {/* Loading Indicator */}
      <div className="absolute bottom-20 flex gap-2">
        <span className="w-2 h-2 bg-white/70 rounded-full animate-loading-dot" style={{ animationDelay: '0s' }} />
        <span className="w-2 h-2 bg-white/70 rounded-full animate-loading-dot" style={{ animationDelay: '0.2s' }} />
        <span className="w-2 h-2 bg-white/70 rounded-full animate-loading-dot" style={{ animationDelay: '0.4s' }} />
      </div>
    </div>
  );
};
